import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { Client } from '@core/interfaces/client.interface';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  availableLocales: Subject<string[]> = new Subject<string[]>();
  clientDefaultLocale: Subject<string> = new Subject<string>();
  useBrowserDefaultLangOnWebsite: Subject<boolean> = new Subject<boolean>();
  navigatorHistory: any = [];
  client: Client;
  private devHosts = [
    'https://artsaas.artsaas.e1s.it/',
    'http://10.2.12.200',
    'localhost',
    'http://localhost',
    'https://localhost',
  ];

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }
}
